// extracted by mini-css-extract-plugin
export default {"downloadPdf":"DownloadPdf_downloadPdf__i8Wmz","textRow":"DownloadPdf_textRow__YY622","actionsRow":"DownloadPdf_actionsRow__smAjh"};